import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconScan = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 7V5a2 2 0 0 1 2-2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 3h2a2 2 0 0 1 2 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 17v2a2 2 0 0 1-2 2h-2" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 21H5a2 2 0 0 1-2-2v-2" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 3,
			y1: 12,
			x2: 21,
			y2: 12
		})
	]
});
export default SvgIconScan;
